<template>
   <div class="flex-column">
      <div class="flex-column" v-for="(item, index) in dataList" :key="index">
         <div>
            <span>{{ item.name }}</span>
            <span>{{ item.uid }}</span>
         </div>
         <el-upload class="upload-file" accept=".yaml" name="file" :show-file-list="false"
            :action="$util.aioIP + '/api/m/sys/config/file/v365/upload'"
            :headers="{ channelCode: $util.envType == 'pre' ? 'iydsjpre' : 'iydsj' }"
            :data="{ schoolId: schoolId, uid: item.uid, userName: $store.state.user.name }" :on-success="handleSuccess"
            :on-error="handleError">
            <el-button>选择上传文件</el-button>
         </el-upload>
         <div class="flex-row-around">
            <span>{{ item.fileName }}</span>
            <span>{{ item.createTime }}</span>
            <span>{{ item.uploader }}</span>
         </div>
         <div class="flex-row-between">
            <el-button type="text" @click="clickDownload(item)">下载</el-button>
            <el-button type="text" @click="clickUploadConfigRecord(item)">查看上传记录</el-button>
         </div>
         <div class="sperate-line"></div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      schoolId: {
         type: String,
         default: ''
      },
      stadiumConfig: {
         type: Object,
         default: () => { }
      }
   },

   data() {
      return {
         dataList: [],
      }
   },

   watch: {
      schoolId(value) {
         this.queryList();
      }
   },

   methods: {
      // 查询硬件防作弊设备配置列表
      queryList() {
         this.$http({
            url: this.$util.aioIP + '/api/m/sys/config/file/v365/list',
            method: 'get',
            params: { schoolId: this.schoolId, type: 7 },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            const deviceList = res.data.data || [];
            if (this.stadiumConfig && this.stadiumConfig.cameraConfig) {
               this.dataList = deviceList.filter((item) => item.uid !== this.stadiumConfig.cameraConfig.boxId);
            } else {
               this.dataList = deviceList
            }
         }).catch((err) => {
            this.dataList = [];
         });
      },
      // 上传成功
      handleSuccess(res, file, fileList) {
         this.queryList();
      },
      // 上传失败
      handleError(err) {
         this.$message.error('上传失败');
      },
      // 点击下载硬件防作弊配置
      clickDownload(item) {
         location.href = this.$util.aioIP + '/file' + item.filePath;
      },
      // 点击查看硬件防作弊上传记录
      clickUploadConfigRecord(item) {
         this.$emit('click-record', item);
      },
   }
}
</script>

<style scoped>
.upload-file .el-button {
   width: 100%;
   height: 36px;
}

.sperate-line {
   margin: 10px 0px;
   height: 1px;
   background-color: #e8e8e8;
}
</style>


// WEBPACK FOOTER //
// HardwareConfig.vue?5b9b933a